<hr />
<div class="rs-flex-row">
  <div class="rs-flex-column">
    <p class="rs-tit5">
      <span>{{ 'bills.cover.odbDetails.subtotal' | translate }}</span>
    </p>
  </div>
  <div class="rs-flex-column rs-flex-shrink">
    <p [ngClass]="{ 'text-right': (selectIsUserSE$ | async) === true }">
      <px-currency-amount
        [amount]="amount"
        [amountClass]="'rs-price-s rs-price-neutral'"
      ></px-currency-amount>
      <span
        *ngIf="(selectIsUserSE$ | async) === true && showVatText"
        data-cy="myBillSubTotalAmountExcludesVat"
      >
        <br />
        {{ 'bills.cover.vatExclusive' | translate }}
      </span>
    </p>
  </div>
</div>
